import React from 'react';

import ForcePasswordResetModal from './forcePasswordResetModal';
import { useForcedPasswordReset } from './useForcedPasswordReset';

/**
 * Raises the forced-reset wall when the API reports an outstanding rotation.
 *
 * A component calling a hook rather than a HOC wrapping one, so the caller composes it by rendering
 * it. That also makes the ordering against the MFA wall explicit at the call site instead of
 * implied by which wrapper is outermost.
 */
const ForcePasswordResetWall = () => {
  const requiresPasswordReset = useForcedPasswordReset();

  return requiresPasswordReset ? <ForcePasswordResetModal /> : null;
};

export default ForcePasswordResetWall;
